import { Progress, Spin, Tag } from "antd";
import { useTranslation } from "react-i18next";
import { LoadingOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import careerStages from "shared/constants/careerStages";
import { getI18nGenre } from "shared/helpers/i18nGenre";
import { ReactComponent as UnfollowIcon } from "shared/assets/images/unfollow-icon.svg";
import "./Home.scss";
import { useHistory } from "react-router-dom";
import { getI18nCoutry } from "shared/helpers/i18nCountry";

const stageColors = [
  "#FF5833",
  "#E4BC5C",
  "#C1EB97",
  "#39D68D",
  "#37B1E4",
  "#455FE4",
  "#874FC6",
  "#F05576",
  "#E44545",
  "#F3795E",
];

interface ArtistCardProps {
  artistIdStrm: string;
  artistName: string;
  careerStage: number;
  stageProgress: number;
  imageUrl: string;
  country: string;
  genresStrm: string[];
  position?: number;
  loading?: boolean;
  onRemove?: (id: string) => void;
}

const ArtistCard: React.FC<ArtistCardProps> = (props) => {
  const {
    artistIdStrm,
    artistName,
    imageUrl,
    country,
    genresStrm,
    careerStage,
    stageProgress,
    position,
    loading,
    onRemove,
  } = props;
  const { t, i18n } = useTranslation("radar");
  const history = useHistory();
  const { genres } = useSelector((state: any) => state.genres);
  const { countries } = useSelector((state: any) => state.countries);
  const wrappGetI18nGenre = (genre: string) =>
    getI18nGenre(genre, i18n, genres);
  const wrappGetI18nCountry = (country: string) =>
    getI18nCoutry(country, i18n, countries);

  if (!artistIdStrm && !artistName)
    return (
      <div className="artist-card-shadow">
        <div className="artist-card"></div>
      </div>
    );

  if (loading)
    return (
      <div className="artist-card-shadow">
        <div className="artist-card">
          <Spin indicator={<LoadingOutlined style={{ fontSize: 64 }} spin />} />
        </div>
      </div>
    );

  return (
    <div className="artist-card-shadow">
      {position && (
        <div
          className="image-position"
          style={{ color: stageColors[position - 1] || "#fff" }}
        >{`${position}º`}</div>
      )}
      <div className="artist-card">
        <span className="name">{artistName}</span>
        <div className="image-container">
          <img src={imageUrl} alt="" style={{ opacity: imageUrl }} />
        </div>
        <div
          style={{
            marginTop: 12,
            width: "100%",
            minHeight: 24,
            gap: "6px 0",
            display: "flex",
            flexWrap: "nowrap",
            justifyContent: "center",
          }}
        >
          {genresStrm?.slice(0, 1).map((genre: any) => (
            <Tag
              key={genre}
              color="transparent"
              style={{
                border: "2px solid #E4BC5C",
                color: "#E4BC5C",
                padding: "0px 8px",
              }}
            >
              {wrappGetI18nGenre(genre)}
            </Tag>
          ))}
          <Tag
            style={{ border: "2px solid #fff", padding: "0px 8px" }}
            hidden={!country}
          >
            {wrappGetI18nCountry(country)}
          </Tag>
        </div>
        <div style={{ margin: 0, width: "100%" }}>
          <strong
            style={{
              fontSize: 12,
              color: "#fff",
              display: "flex",
              justifyContent: "center",
            }}
          >
            {t("components.ArtistComparator.stage")}
            {` `}
            {t(`pages.Radar.${careerStages[careerStage - 1 || 0]}`)}
          </strong>
        </div>
        <div style={{ margin: "0 16px", width: "100%" }}>
          <Progress
            strokeColor={{
              "0%": "#874FC6",
              "50%": "#874FC6",
              "1000%": "#BD8EF2",
            }}
            style={{ color: "white" }}
            percent={Math.ceil(stageProgress * 100 || 0)}
          />
        </div>
        <div className="buttons">
          <button
            onClick={() =>
              history.push("/artist-profile", {
                artist: { artistIdStrm: artistIdStrm },
              })
            }
          >
            {t("pages.Home.seeProfile")}
          </button>
          {onRemove && (
            <UnfollowIcon
              className="unfollow"
              onClick={() => onRemove(artistIdStrm)}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ArtistCard;
